import React, { useEffect, useState, useRef } from "react";
import { RiAdminFill } from "react-icons/ri";
import { ImPlus } from "react-icons/im";
import pages from "../index";
import { Collapse } from "reactstrap";
import {
  ScrollArea,
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Avatar,
  AvatarImage,
  useToast,
} from "../../components/ui";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";
import { Header } from "../../components/modules";
import { FaTimes, FaCheckCircle } from "react-icons/fa";
import { FiFileText } from "react-icons/fi";
import Context from "../../Context";
import { IoMdTrash } from "react-icons/io";
import { MdPersonSearch } from "react-icons/md";
import { Spinner } from "reactstrap";
import { statuses } from "../../constants";
import { CSVLink, CSVDownload } from "react-csv";
import { thaiDate, role } from "../../util";
import { DatePicker, Spin } from "antd";
import th from "antd/es/date-picker/locale/th_TH";
import dayTh from "dayjs/locale/th";
import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";

dayjs.extend(buddhistEra);
dayjs.locale(dayTh);

const buddhistLocale = {
  ...th,
  lang: {
    ...th.lang,
    fieldDateFormat: "DD-MM-BBBB",
    fieldDateTimeFormat: "DD-MM-BBBB HH:mm:ss",
    yearFormat: "BBBB",
    cellYearFormat: "BBBB",
  },
};

export const ReportReserveOrder = () => {
  const downloadRef = useRef(null);
  const { toast } = useToast();
  const { callApi, configs } = Context();
  const [orders, setOrders] = useState(false);
  const [selectedRoundDate, setSelectedRoundDate] = useState(configs.roundDate);

  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState(false);
  const [csvFileName, setCsvFileName] = useState("");
  const [csvData, setCsvData] = useState([]);
  const [downloaded, setDownloaded] = useState([]);

  useEffect(() => {
    if (csvFileName && !downloaded.includes(csvFileName)) {
      downloadRef.current.childNodes[0].click();
      setDownloaded((old) => [...old, csvFileName]);
    }
  }, [csvFileName]);

  const getOrders = async () => {
    setLoading(true);

    const allUserData = [];
    let keepGoing = true;
    let currentIndex = 0;
    let startAtId = "";
    let limit = 5000;

    while (keepGoing) {
      console.log(`calling index ${currentIndex}-${currentIndex + limit}`);
      const data = await callApi("orders-getAll", {
        roundDate: selectedRoundDate,
        queries: [["isReserveOrder", true]],
        limit: 50000,
        orderBy: ["createdAt", "desc"],
      });

      if (data.length < limit || !data.length || !data) {
        console.log("stop");
        keepGoing = false;
        setLoading(false);
      } else {
        console.log(`fetching size: ${data.length}`);
        console.log("id", data[data.length - 1].id);
        startAtId = data[data.length - 1].id;
      }

      allUserData.push(...data);
      console.log(`allUserData size: ${allUserData.length}`);
      currentIndex += limit;
    }

    const summaryData = allUserData.reduce((acc, order) => {
      const { createdBy, status, reservedBy } = order;
      if (acc[createdBy?.userId || reservedBy]) {
        acc[createdBy?.userId || reservedBy][status] += 1;
      } else {
        acc[createdBy?.userId || reservedBy] = {
          createdBy: `${createdBy?.firstName} ${createdBy?.lastName} #${
            createdBy?.userId || reservedBy
          }`,
          approved: status === "approved" ? 1 : 0,
          canceled: status === "canceled" ? 1 : 0,
        };
      }

      return acc;
    }, {});
    setLoading(false);

    setSummary(Object.values(summaryData));

    setOrders(allUserData.sort((a, b) => b.createdAt - a.createdAt));
  };

  const handleDownload = async () => {
    const csvBody = [[`รายงานออเดอร์จองสิทธิ์ งวด ${selectedRoundDate}`], []];
    csvBody.push([]);
    csvBody.push([`สรุป`]);
    csvBody.push([`ผู้สร้างคำสั่งซื้อ`, `รวม`, `อนุมัติ`, `ยกเลิก`]);
    csvBody.push(
      ...summary.map((e) => [
        e.createdBy,
        e.approved + e.canceled,
        e.approved,
        e.canceled,
      ])
    );
    csvBody.push([]);
    csvBody.push([
      "ลำดับ",
      "วัน-เวลา",
      "รูปแบบการซื้อ",
      "รหัสคำสั่งซื้อ",
      "ผู้สร้าง",
      "ราคา",
      "สถานะ",
    ]);
    orders.forEach((order, index) =>
      csvBody.push([
        index + 1,
        new Date(order.createdAt).toLocaleDateString("th-TH", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
        }),
        order.shortId,
        order.deliverChannel,
        order.createdBy?.firstName +
          " " +
          order.createdBy?.lastName +
          ` #${order.userId}`,
        order.totalPrice,
        order.status,
      ])
    );

    setCsvData(csvBody);
    setCsvFileName(`รายงานออเดอร์จองสิทธิ์_${selectedRoundDate}.csv`);
  };

  return (
    <div className="h-fit w-full min-w-[1024px] max-w-[1600px] mx-auto">
      {/* header */}
      <Header
        header="Report"
        subHeader="รายงานออเดอร์จองสิทธิ์_"
        icon={<FiFileText className="text-blue" />}
      />

      <div className="relative w-96 bg-white rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
        <div className="p-3 border-b border-gray-300">
          <p className="font-semibold ">ค้นหาคำสั่งซื้อสลาก</p>
        </div>
        <div className="grid grid-cols-2 items-center gap-3 p-3 ">
          <div className="gap-2 col-span-2">
            <p className="font-medium text-xs">งวด</p>
            <div>
              <select
                className="border-2 w-full h-9 border-gray-300 rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
                value={selectedRoundDate}
                onChange={(e) => setSelectedRoundDate(e.target.value)}
              >
                {configs.roundDates.map((roundDate) => (
                  <option key={roundDate} value={roundDate}>
                    {roundDate}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <button
            disabled={loading}
            className="flex items-center justify-center gap-1 py-2 px-3 bg-blue text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:opacity-60"
            onClick={() => {
              getOrders();
            }}
          >
            {loading ? (
              <Spinner className="w-3 h-3" />
            ) : (
              <MdPersonSearch className="text-white" />
            )}
            ค้นหา
          </button>
          <button
            disabled={!orders.length}
            className="flex items-center justify-center gap-1 py-2 px-3 bg-[rgb(59,176,101)] text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-300 disabled:hover:opacity-100 disabled:cursor-not-allowed"
            onClick={() => {
              handleDownload();
            }}
          >
            {/* {loading ? (
              <Spinner className="w-3 h-3" />
            ) : (
              <MdPersonSearch className="text-white" />
            )} */}
            ดาวโหลด
          </button>
        </div>
      </div>
      <div ref={downloadRef}>
        <CSVLink
          data={csvData}
          filename={csvFileName}
          style={{ display: "none" }}
        >
          Download me
        </CSVLink>
      </div>
      {summary && (
        <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
          <div className="flex bg-white gap-3 items-center p-3 border-b border-gray-300">
            <p className="font-semibold ">สรุป</p>{" "}
          </div>
          {/* <ScrollArea className={`h-96`}> */}
          <Table>
            <TableHeader className={`bg-[#f2f3f5]`}>
              <TableRow>
                <TableHead className="">ผู้สร้างคำสั่งซื้อ</TableHead>
                <TableHead className="text-right">รวม</TableHead>
                <TableHead className="text-right">อนุมัติ</TableHead>
                <TableHead className="text-right">ยกเลิก</TableHead>
              </TableRow>
            </TableHeader>

            <TableBody className={``}>
              {orders.length > 0 ? (
                summary.map((order, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell className={`font-medium`}>
                        {order.createdBy}
                      </TableCell>
                      <TableCell className="font-medium text-right tracking-widest font-mono">
                        {order.approved + order.canceled}
                      </TableCell>
                      <TableCell className="text-right">
                        {order.approved}
                      </TableCell>
                      <TableCell className="text-right font-medium">
                        {order.canceled}
                      </TableCell>

                      {/* <TableCell>{order.cancelerName}</TableCell> */}
                    </TableRow>
                  );
                })
              ) : (
                <TableCell className="" colSpan="6">
                  <div className="min-h-52 w-full flex justify-center items-center font-medium text-[#969797]">
                    <div>
                      <MdPersonSearch className="text-white" />
                      ไม่พบคำสั่งซื้อ
                    </div>
                  </div>
                </TableCell>
              )}
            </TableBody>
          </Table>
          {/* </ScrollArea> */}
        </div>
      )}
      {orders && (
        <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
          <div className="flex bg-white gap-3 items-center p-3 border-b border-gray-300">
            <p className="font-semibold ">คำสั่งซื้อทั้งหมด</p>{" "}
            <p className="text-xs font-semibold text-[#969797]">
              {orders.length} คำสั่งซื้อ
            </p>
          </div>
          {/* <ScrollArea className={`h-96`}> */}
          <Table>
            <TableHeader className={`bg-[#f2f3f5]`}>
              <TableRow>
                <TableHead className="">วันที่-เวลา</TableHead>
                <TableHead className="text-center">รหัสคำสั่งซื้อ</TableHead>
                <TableHead className="text-center">ช่องทางการซื้อ</TableHead>
                <TableHead>ผู้สร้าง</TableHead>
                <TableHead className="text-right">ราคา</TableHead>
                <TableHead className="text-right">สถานะ</TableHead>
                {/* <TableHead>ผู้ยกเลิก</TableHead> */}
              </TableRow>
            </TableHeader>

            <TableBody className={``}>
              {orders.length > 0 ? (
                orders.map((order) => {
                  return (
                    <TableRow key={order.shortId}>
                      <TableCell className={`font-medium`}>
                        {new Date(order.createdAt).toLocaleDateString("th-TH", {
                          year: "numeric",
                          month: "numeric",
                          day: "numeric",
                          hour: "numeric",
                          minute: "numeric",
                        })}{" "}
                        น.
                      </TableCell>
                      <TableCell className="font-medium text-center tracking-widest font-mono">
                        {order.shortId}
                      </TableCell>
                      <TableCell className="text-center">
                        {order.deliverChannel}
                      </TableCell>
                      <TableCell className="font-medium">
                        {order.reservedBy
                          ? order.reservedBy
                          : order.createdBy?.firstName +
                            " " +
                            order.createdBy?.lastName +
                            ` (#${order.createdBy?.userId})`}
                      </TableCell>

                      <TableCell className="font-medium text-right">
                        {order.totalPrice.toLocaleString()}
                      </TableCell>
                      <TableCell className="font-medium text-right">
                        {order.status}
                      </TableCell>
                      {/* <TableCell>{order.cancelerName}</TableCell> */}
                    </TableRow>
                  );
                })
              ) : (
                <TableCell className="" colSpan="6">
                  <div className="min-h-52 w-full flex justify-center items-center font-medium text-[#969797]">
                    <div>
                      <MdPersonSearch className="text-white" />
                      ไม่พบคำสั่งซื้อ
                    </div>
                  </div>
                </TableCell>
              )}
            </TableBody>
          </Table>
          {/* </ScrollArea> */}
        </div>
      )}
    </div>
  );
};

// import { useEffect, useState, useRef } from "react";
// import Context from "../../Context";
// import {
//   Sheet,
//   SheetContent,
//   SheetTrigger,
//   Switch,
//   Table,
//   TableBody,
//   TableCaption,
//   TableCell,
//   TableHead,
//   TableHeader,
//   TableRow,
// } from "../../components";
// import {
//   Select,
//   SelectContent,
//   SelectItem,
//   SelectTrigger,
//   SelectValue,
// } from "../../components/base";
// import constant from "../../constants";
// import { CSVLink, CSVDownload } from "react-csv";

// export const ReportReserveOrder = () => {
//   const downloadRef = useRef(null);
//   const { callApi, updateConfig, configs } = Context();
//   const [selectedRoundDate, setSelectedRoundDate] = useState(configs.roundDate);
//   const [orderData, setOrderData] = useState([]);
//   const [filterByUser, setFilterByUser] = useState([]);
//   const [csvFileName, setCsvFileName] = useState("");
//   const [csvData, setCsvData] = useState([]);
//   const [downloaded, setDownloaded] = useState([]); // to stop auto download (only happen on local)

//   useEffect(() => {
//     if (csvData.length > 0) {
//       downloadRef.current.childNodes[0].click();
//     }
//     // setDownloaded((old) => [...old, csvFileName]);
//   }, [csvFileName]);

//   const fetchData = async () => {
//     const result = await callApi("orders-getAll", {
//       roundDate: selectedRoundDate,
//       queries: [["isReserveOrder", true]],
//       limit: 50000,
//       orderBy: ["createdAt", "desc"],
//     });

//     setOrderData(result);

//     const filterByUser = result.reduce((acc, order) => {
//       const { reservedBy, status } = order;
//       if (acc[reservedBy]) {
//         if (acc[reservedBy][status]) {
//           acc[reservedBy][status] += 1;
//         } else {
//           acc[reservedBy] = { ...acc[reservedBy], [status]: 1 };
//         }
//         acc[reservedBy].total += 1;
//       } else {
//         acc[reservedBy] = { [status]: 1, total: 1 };
//       }
//       return acc;
//     }, {});

//     setFilterByUser(filterByUser);
//   };

//   const handleDownload = async (data, type) => {
//     let acc = [];

//     if (type === "mini") {
//       acc.push(["รหัสผู้สร้าง", "ออเดอร์ทั้งหมด", "อนุมัติ", "ไม่อนุมัติ"]);
//       const datax = Object.entries(data).map((entry) => {
//         return [
//           entry[0],
//           entry[1].total,
//           entry[1].approved || 0,
//           (entry[1].canceled || 0) + (entry[1].pending || 0),
//         ];
//       });

//       acc.push(...datax);
//       setCsvFileName(
//         `สรุปรายงานออเดอร์จองสิทธิ์แยกตามผู้สร้าง_${selectedRoundDate}.csv`
//       );
//     } else {
//       acc = orderData.map((x) => {
//         return [
//           new Date(parseInt(x.createdAt)).toLocaleString() === "Invalid Date"
//             ? x.createdAtDate.split("-")[2] +
//               "/" +
//               x.createdAtDate.split("-")[1] +
//               "/" +
//               x.createdAtDate.split("-")[0]
//             : new Date(parseInt(x.createdAt)).toLocaleString(),
//           x.shortId,
//           x.status,
//           x.reservedBy,
//         ];
//       });
//       acc.unshift(["วันที่", "รหัสออเดอร์", "สถานะ", "รหัสผู้สร้าง"]);

//       setCsvFileName(`รายงานออเดอร์จองสิทธิ์_${selectedRoundDate}.csv`);
//     }

//     console.log(acc);
//     setCsvData(acc);
//   };
//   return (
//     <div className="bg-white max-w-[1200px] mb-24  p-8 rounded-2xl drop-shadow-xl">
//       <div ref={downloadRef}>
//         <CSVLink
//           data={csvData}
//           filename={csvFileName}
//           style={{ display: "none" }}
//         ></CSVLink>
//       </div>
//       <p className="text-3xl font-semibold">รายงานออเดอร์จองสิทธิ์</p>
//       <div className="flex items-center gap-4 mt-4 max-w-80">
//         <p className="text-lg font-bold">งวด</p>
//         <Select
//           value={selectedRoundDate}
//           onValueChange={(e) => setSelectedRoundDate(e)}
//         >
//           <SelectTrigger className="my-1 text-md font-medium">
//             <SelectValue placeholder="-- โปรดเลือก --" />
//           </SelectTrigger>
//           <SelectContent className="bg-black">
//             {configs.roundDates.map((roundDate) => {
//               return (
//                 <SelectItem
//                   className="text-lg font-medium text-white bg-gray-950 hover:bg-gray-700"
//                   value={roundDate}
//                 >
//                   {roundDate}
//                 </SelectItem>
//               );
//             })}
//           </SelectContent>
//         </Select>

//         <button
//           className="h-12 my-4 px-4 bg-gray-950 hover:bg-primary  disabled:hover:bg-gray-950 duration-150 text-white font-bold rounded-[0.5rem] disabled:cursor-not-allowed disabled:opacity-50"
//           onClick={fetchData}
//         >
//           ค้นหา
//         </button>
//       </div>
//       <div
//         className={`max-w-[789px] mt-16 mb-24 ${
//           orderData.length === 0 && "hidden"
//         }`}
//       >
//         <div className="flex gap-4 mb-12 items-center">
//           <p className="text-xl font-semibold">
//             สรุปรายงานออเดอร์จองสิทธิ์แยกตามผู้สร้าง
//           </p>
//           <button
//             className="h-8 px-4 bg-gray-950 hover:bg-primary  disabled:hover:bg-gray-950 duration-150 text-white text-sm font-bold rounded-[0.5rem] disabled:cursor-not-allowed disabled:opacity-50"
//             onClick={() => handleDownload(filterByUser, "mini")}
//           >
//             ดาวน์โหลด
//           </button>
//         </div>

//         <Table>
//           <TableHeader>
//             <TableRow>
//               <TableHead className="">รหัสผู้สร้าง</TableHead>
//               <TableHead className="text-center">ออเดอร์ทั้งหมด</TableHead>
//               <TableHead className="text-center">อนุมัติ</TableHead>
//               <TableHead className="text-center">ไม่อนุมัติ</TableHead>
//             </TableRow>
//           </TableHeader>
//           <TableBody>
//             {Object.entries(filterByUser).map(([id, order]) => {
//               return (
//                 <TableRow key={id}>
//                   <TableCell className="font-medium">
//                     <div
//                       className={`
//                        flex items-center bg-gray-950 justify-center w-fit py-1 px-2 rounded-[0.5rem] text-xs text-white font-semibold cursor-pointer`}
//                       onClick={() =>
//                         window.open(
//                           `https://admin.hongthongone.com/users/${id}`,
//                           "__blank"
//                         )
//                       }
//                     >
//                       {id}
//                     </div>
//                   </TableCell>
//                   <TableCell>
//                     <div
//                       className={`
//                        flex items-center mx-auto bg-gray-950 justify-center w-fit py-1 px-2 rounded-[0.5rem] text-xs text-white font-semibold cursor-pointer`}
//                     >
//                       {order.total || 0}
//                     </div>
//                   </TableCell>
//                   <TableCell>
//                     <div
//                       className={`flex items-center bg-green-600 mx-auto justify-center w-fit py-1 px-2 rounded-[0.5rem] text-xs text-white font-semibold`}
//                     >
//                       {order.approved || 0}
//                     </div>
//                   </TableCell>
//                   <TableCell>
//                     <div
//                       className={`
//                        flex items-center bg-danger justify-center mx-auto w-fit py-1 px-2 rounded-[0.5rem] text-xs text-white font-semibold cursor-pointer`}
//                     >
//                       {order.canceled + (order.pending || 0) || 0}
//                     </div>
//                   </TableCell>
//                 </TableRow>
//               );
//             })}
//           </TableBody>
//         </Table>
//       </div>
//       <div
//         className={`max-w-[789px] mt-16  ${orderData.length === 0 && "hidden"}`}
//       >
//         <div className="flex gap-4 mb-12 items-center">
//           <p className="text-xl font-semibold">
//             รายงานออเดอร์จองสิทธิ์ ({orderData.length} ออเดอร์)
//           </p>
//           <button
//             className="h-8 px-4 bg-gray-950 hover:bg-primary  disabled:hover:bg-gray-950 duration-150 text-white text-sm font-bold rounded-[0.5rem] disabled:cursor-not-allowed disabled:opacity-50"
//             onClick={() => handleDownload(orderData)}
//           >
//             ดาวน์โหลด
//           </button>
//         </div>

//         <Table>
//           <TableHeader>
//             <TableRow>
//               <TableHead className="">วัน - เวลาที่สร้าง</TableHead>
//               <TableHead className="text-center">รหัสออเดอร์</TableHead>
//               <TableHead className="text-center">สถานะ</TableHead>
//               <TableHead className="text-right">รหัสผู้สร้าง</TableHead>
//             </TableRow>
//           </TableHeader>
//           <TableBody>
//             {orderData.map((order) => {
//               return (
//                 <TableRow key={order.shortId}>
//                   <TableCell className="font-medium">
//                     {new Date(parseInt(order.createdAt)).toLocaleString() ===
//                     "Invalid Date"
//                       ? order.createdAtDate.split("-")[2] +
//                         "/" +
//                         order.createdAtDate.split("-")[1] +
//                         "/" +
//                         order.createdAtDate.split("-")[0]
//                       : new Date(parseInt(order.createdAt)).toLocaleString()}
//                   </TableCell>
//                   <TableCell>
//                     <div
//                       className={`
//                        flex items-center mx-auto bg-gray-950 justify-center w-fit py-1 px-2 rounded-[0.5rem] text-xs text-white font-semibold cursor-pointer`}
//                       onClick={() =>
//                         window.open(
//                           `https://admin.hongthongone.com/orders/${order.id}`,
//                           "__blank"
//                         )
//                       }
//                     >
//                       {order.shortId}
//                     </div>
//                   </TableCell>
//                   <TableCell>
//                     <div
//                       className={`${
//                         order.status === "approved"
//                           ? "bg-green-600"
//                           : order.status === "pending"
//                           ? "bg-primary"
//                           : "bg-danger"
//                       } flex items-center mx-auto justify-center w-fit py-1 px-2 rounded-[0.5rem] text-xs text-white font-semibold`}
//                     >
//                       {constant.statusesTranslate[order.status]}
//                     </div>
//                   </TableCell>
//                   <TableCell className="flex justify-end items-center">
//                     <div
//                       className={`
//                        flex items-center bg-gray-950 justify-center w-fit py-1 px-2 rounded-[0.5rem] text-xs text-white font-semibold cursor-pointer`}
//                       onClick={() =>
//                         window.open(
//                           `https://admin.hongthongone.com/users/${order.reservedBy}`,
//                           "__blank"
//                         )
//                       }
//                     >
//                       {order.reservedBy}
//                     </div>
//                   </TableCell>
//                 </TableRow>
//               );
//             })}
//           </TableBody>
//         </Table>
//       </div>
//     </div>
//   );
// };
